import React from 'react';
import './HeaderBar.scss';

interface HeaderBarProps {
  title?: string;
}

export const HeaderBar: React.FC<HeaderBarProps> = ({ title, children }) => (
  <div className="header-bar">
    <h2 className="header-bar__title">{title}</h2>
    {children ? <div className="header-bar__buttons">{children}</div> : null}
  </div>
);
